import React, { useState } from "react";
import { X, ChevronLeft } from "lucide-react";
import { buildWaLink } from "../lib/api";

// 4 operator ferry — img = thumbnail poster (untuk grid pilihan)
// scheduleImgs = gambar jadwal keberangkatan (ditampilkan setelah ferry dipilih)
const FERRIES = [
  {
    name: "Batam Fast",
    img: "/services/batam-fast.jpeg",
    scheduleImgs: ["/services/batam-fast-schedule.jpeg"],
  },
  {
    name: "Dolphin",
    img: "/services/dolphin.jpeg",
    scheduleImgs: [
      "/services/dolphin-schedule-batam-center.png",
      "/services/dolphin-schedule-harbour-bay.png",
    ],
  },
  {
    name: "Sindo Ferry",
    img: "/services/sindo-ferry.jpeg",
    scheduleImgs: ["/services/sindo-ferry-schedule.jpeg"],
  },
  {
    name: "Majestic",
    img: "/services/majestic.jpeg",
    scheduleImgs: ["/services/Majestic-schedule.png"],
  },
  {
    name: "Putri Anggreni",
    img: "/services/putri-anggreni.png",
    scheduleImgs: ["/services/putri-anggreni-schedule.png"],
  },
];

const GRADIENTS = [
  "linear-gradient(135deg,#1E7FC2,#0E9A57)",
  "linear-gradient(135deg,#0E9A57,#0C2230)",
  "linear-gradient(135deg,#B7892F,#0C2230)",
  "linear-gradient(135deg,#1E7FC2,#0C2230)",
];

export const TicketModal = ({ open, onClose }) => {
  const [selected, setSelected] = useState(null);

  if (!open) return null;

  const close = () => {
    setSelected(null);
    onClose();
  };

  const orderFerry = (name) => {
    const msg = `Halo CEO Travel 👋, saya mau tanya tiket ferry *${name}*. Boleh info jadwal & harga?`;
    window.open(buildWaLink(msg), "_blank");
  };

  const askFlight = () => {
    const msg = "Halo CEO Travel 👋, saya mau tanya tiket pesawat. Boleh dibantu info rute & harga?";
    window.open(buildWaLink(msg), "_blank");
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0C2230]/70 p-4 backdrop-blur-sm"
      onClick={close}
      data-testid="ticket-modal"
    >
      <div
        className="relative flex max-h-[92vh] w-full max-w-md flex-col overflow-hidden rounded-3xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ---------- HEADER ---------- */}
        <div className="flex items-start justify-between border-b border-[#0C2230]/8 px-6 py-5">
          <div className="flex items-center gap-2">
            {selected && (
              <button
                onClick={() => setSelected(null)}
                aria-label="Kembali"
                className="-ml-2 rounded-full p-1 text-[#0C2230]/60 transition hover:bg-[#0C2230]/5 hover:text-[#0C2230]"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
            )}
            <div>
              <h3 className="font-[Fraunces] text-xl font-medium text-[#0C2230]">
                {selected ? selected.name : "Tiket Ferry & Pesawat"}
              </h3>
              <p className="mt-0.5 text-xs text-[#0C2230]/60">
                {selected
                  ? "Cek jadwal keberangkatan, lalu order via WhatsApp"
                  : "Pilih ferry untuk lihat jadwal"}
              </p>
            </div>
          </div>
          <button
            onClick={close}
            aria-label="Tutup"
            className="rounded-full p-1 text-[#0C2230]/50 transition hover:bg-[#0C2230]/5 hover:text-[#0C2230]"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* ---------- BODY (scrollable) ---------- */}
        <div className="flex-1 overflow-y-auto">
          {!selected ? (
            /* ===== GRID: pilih ferry ===== */
            <div className="px-6 py-5">
              <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#0C2230]/45">
                Operator Ferry
              </p>
              <div className="grid grid-cols-2 gap-3">
                {FERRIES.map((f, i) => (
                  <button
                    key={f.name}
                    onClick={() => setSelected(f)}
                    data-testid={`ferry-${i}`}
                    className="group relative flex h-32 items-end overflow-hidden rounded-2xl p-3 text-left ring-1 ring-[#0C2230]/10 transition hover:-translate-y-0.5 hover:shadow-lg"
                    style={{ background: GRADIENTS[i % GRADIENTS.length] }}
                  >
                    <img
                      src={f.img}
                      alt={f.name}
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                      className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <span className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0C2230]/85 via-[#0C2230]/10 to-transparent" />
                    <span className="relative z-10 font-[Fraunces] text-base font-medium text-white drop-shadow">
                      {f.name}
                    </span>
                  </button>
                ))}
              </div>

              {/* Flight note */}
              <div className="mt-5 rounded-2xl bg-[#FBFAF6] p-4 text-center">
                <p className="text-sm text-[#0C2230]/70">Butuh tiket pesawat juga?</p>
                <button
                  onClick={askFlight}
                  className="mt-2 inline-flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:bg-[#20bd5a]"
                >
                  💬 Tanya tiket pesawat via WhatsApp
                </button>
              </div>
            </div>
          ) : (
            /* ===== DETAIL: jadwal + order ===== */
            <div className="flex flex-col gap-4 px-4 py-4">
              {selected.scheduleImgs.map((src, i) => (
                <img
                  key={src}
                  src={src}
                  alt={`${selected.name} schedule ${i + 1}`}
                  className="w-full rounded-2xl ring-1 ring-[#0C2230]/10"
                />
              ))}
            </div>
          )}
        </div>

        {/* ---------- FOOTER (tombol order, hanya di detail) ---------- */}
        {selected && (
          <div className="border-t border-[#0C2230]/8 p-4">
            <button
              onClick={() => orderFerry(selected.name)}
              className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#25D366] px-5 py-3.5 text-sm font-bold text-white shadow-md transition hover:bg-[#20bd5a]"
            >
              💬 Order {selected.name} via WhatsApp
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketModal;
